module.exports = __webpack_public_path__ + "img/master-implementer-4.cd429cca.svg";